import { render, staticRenderFns } from "./QRCodeScannerDialog.vue?vue&type=template&id=1f52cf8d&scoped=true&"
import script from "./QRCodeScannerDialog.vue?vue&type=script&lang=ts&"
export * from "./QRCodeScannerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QRCodeScannerDialog.vue?vue&type=style&index=0&id=1f52cf8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52cf8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VIcon,VSpacer})
